/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_Essay_P1Inputs */

const en_pc_cmp_essay_p1 = /** @type {(inputs: Pc_Cmp_Essay_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For most people the honest answer is: for the things they do every week, yes. Reading long documents, searching them, leaving comments, filling forms, reordering pages and merging files are the core of PDF work, and PdfCraft handles all of them without a subscription. Over three years, an Acrobat Pro plan costs about US$720 per person. PdfCraft costs nothing, on as many machines as you like.`)
};

const zh_pc_cmp_essay_p1 = /** @type {(inputs: Pc_Cmp_Essay_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对大多数人来说，诚实的答案是：对于每周都在做的事情，是的。阅读长文档、搜索、批注、填写表单、调整页面顺序、合并文件，这些是 PDF 工作的核心，PdfCraft 都能完成，而且不需要订阅。三年下来，Acrobat Pro 每人约需 720 美元；PdfCraft 一分钱都不花，想装几台就装几台。`)
};

/**
* | output |
* | --- |
* | "For most people the honest answer is: for the things they do every week, yes. Reading long documents, searching them, leaving comments, filling forms, reorde..." |
*
* @param {Pc_Cmp_Essay_P1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_essay_p1 = /** @type {((inputs?: Pc_Cmp_Essay_P1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_Essay_P1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_essay_p1(inputs)
	return zh_pc_cmp_essay_p1(inputs)
});
export { pc_cmp_essay_p1 as "pc.cmp.essay_p1" }